import { useNavigate } from "react-router-dom";
import { Button } from "@/components/Button/Button";
import { ROUTES } from "../CorporateSignupPanel";

export default function CorporateAssist() {
  const navigate = useNavigate();

  const handleSubmit = () => {
    navigate(ROUTES.CORPORATE_INFO);
  };

  return (
    <div className="flex flex-col gap-4" data-testid="container-corporate-assist">
      <div className="flex justify-between items-center" data-testid="container-corporate-assist-header">
        <h1 className="text-2xl font-normal" data-testid="text-corporate-assist-heading">
          THANK YOU FOR REGISTERING WITH PAYTRIE
        </h1>
      </div>

      <div className="mt-8 flex flex-col gap-4" data-testid="container-corporate-assist-content">
        <p className="text-base" data-testid="text-corporate-assist-message">
          Please allow up to 24 hours for a PayTrie support staff to verify your
          identity. If we require more information, we will contact you via
          email.
        </p>

        <Button
          onClick={handleSubmit}
          className="mt-4 inline-flex items-center py-8 px-4 w-full justify-center lg:gap-2"
          data-testid="btn-corporate-assist-return"
        >
          Return to Homepage
        </Button>
      </div>
    </div>
  );
}

/*
Component Improvement Suggestions:
- This component is a simple screen with minimal functionality
- Consider adding more comprehensive information about next steps for the user
- Add a support email or contact method as a direct link
- Include a loading indicator during navigation
- This component could benefit from an estimated time for verification
- Consider adding progress indicators to show the completion of the registration process
- Provide more context about what happens after verification
- Add the ability for users to check their verification status
*/
